<template>
  <div class="fnton">
    <div class="title">
      <img src="../assets/image/tips5_title.jpg" />
    </div>
    <div class="con">
      <img src="../assets/image/tips4conimg.jpg" />
    </div>
    <div class="con con2">
      <img src="../assets/image/tips4con01.jpg" />
    </div>
    <div class="botNav">
      <div class="auto"></div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.fnton {
  float: left;
  width: 100%;
}
.title {
  float: left;
  width: 100%;
  height: 175px;
  text-align: center;
}
.con {
  float: left;
  width: 100%;
  height: 870px;
  background: #f5f5f5;
  text-align: center;
}
.con2 {
  height: 443px;
  background: #fff;
}
.botNav {
  float: left;
  width: 100%;
  height: 78px;
  border-top: 1px solid #dcdcdc;
  background: #eee;
}
.botNav .auto {
  margin: 0 auto;
  width: 1200px;
  height: 100%;
  background: url(../assets/image/navbot.jpg) no-repeat center;
}
</style>